export function isAdminOrSuperAdmin(profileType?: string): boolean {
  return profileType === 'admin' || profileType === 'super_admin';
}

export function isUberAdmin(profileType?: string): boolean {
  return profileType === 'super_admin';
}

export function isDirectorOrAdmin(profileType?: string): boolean {
  return profileType === 'director' || profileType === 'admin' || profileType === 'super_admin';
}

export function canManageClubs(profileType?: string): boolean {
  return profileType === 'director' || profileType === 'manager' || profileType === 'admin' || profileType === 'super_admin';
}
